import React from "react";
var __jsx = React.createElement;
import SingleTrackingStepComponent from "../SingleTrackingStepComponent/SingleTrackingStepComponent";
import CopyCodeComponent from "../CopyCodeComponent/CopyCodeComponent";
import stl from "./TrackingStepsComponent.module.css";
import StarSVG from "../../../../../../../SVGObjects/StarSVG";
import { Link } from "react-router-dom";
import ArrowType2SVG from "../../../../../../../SVGObjects/UiKit/ArrowType2SVG";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
import TrackingReturnStatusSection from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/TrackingReturn/TrackingReturnSection";
// @ts-ignore

import { useMemo } from "react";
import { getStepStatus } from "@/pages/tracking/utls";
var TrackingStepsComponent = function TrackingStepsComponent(_ref) {
  var _details$enable_vas, _details$enable_vas2, _details$referer_code;
  var details = _ref.details,
    isFinance = _ref.isFinance;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBoolean = useBoolean(true),
    collapsed = _useBoolean.value,
    toggleExpand = _useBoolean.toggle;
  var completed = useMemo(function () {
    var _details$steps;
    return details === null || details === void 0 ? void 0 : (_details$steps = details.steps) === null || _details$steps === void 0 ? void 0 : _details$steps.every(function (step) {
      return step.completed === 1 || step.completed === true;
    });
  }, [isFinance, details.id]);
  var status = useMemo(function () {
    var _details$steps2;
    return details === null || details === void 0 ? void 0 : (_details$steps2 = details.steps) === null || _details$steps2 === void 0 ? void 0 : _details$steps2.map(function (step) {
      return getStepStatus(step, details);
    });
  }, [details.id]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-white"
  }, details.return_order_data.status !== null && /*#__PURE__*/React.createElement("div", {
    className: [stl.statusBox, "h-mobile"].join(" ")
  }, /*#__PURE__*/React.createElement(TrackingReturnStatusSection, {
    details: details
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.titleStepsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.headerContainer
  }, /*#__PURE__*/React.createElement("hr", {
    className: "".concat(stl.hr, " m-show")
  }), isFinance ? /*#__PURE__*/React.createElement("strong", {
    className: ["m-hide", stl.sectionTitle].join(" ")
  }, " ", t("finance_order_steps", {
    ns: "web_tracking_finance"
  })) : /*#__PURE__*/React.createElement("strong", {
    className: ["m-hide", stl.sectionTitle].join(" ")
  }, " ", t("track_car_order", {
    ns: "web_tracking_finance"
  })), (details === null || details === void 0 ? void 0 : details.enable_vas) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/finance-remaining-payment/".concat(details === null || details === void 0 ? void 0 : details.order_uuid)),
    state: {
      backFromSteps: true
    },
    className: stl.vasContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.contentCont
  }, /*#__PURE__*/React.createElement(StarSVG, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: stl.vasTitle
  }, details === null || details === void 0 ? void 0 : (_details$enable_vas = details.enable_vas) === null || _details$enable_vas === void 0 ? void 0 : _details$enable_vas.text), /*#__PURE__*/React.createElement("p", null, details === null || details === void 0 ? void 0 : (_details$enable_vas2 = details.enable_vas) === null || _details$enable_vas2 === void 0 ? void 0 : _details$enable_vas2.sub_text))), /*#__PURE__*/React.createElement(ArrowType2SVG, null)), /*#__PURE__*/React.createElement("hr", {
    className: stl.hr
  }))), details.return_order_data.status !== null && /*#__PURE__*/React.createElement("div", {
    className: [stl.statusBox, "h-desktop"].join(" ")
  }, /*#__PURE__*/React.createElement(TrackingReturnStatusSection, {
    details: details
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.trackTitle
  }, t("track_order", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.trackFS, " !p-0")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.trackFsBox, collapsed && completed ? stl.detailsTapsContainerCollapsed : stl.detailsTapsContainer].join(" ")
  }, (details === null || details === void 0 ? void 0 : details.steps) && /*#__PURE__*/React.createElement(React.Fragment, null, details === null || details === void 0 ? void 0 : details.steps.map(function (step, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: [stl.tapItem, collapsed && completed ? stl.tapItemCollapsed : "", completed ? stl.tapItemReturn : ""].join(" "),
      style: {
        //@ts-ignore
        "--idx": idx
      }
    }, /*#__PURE__*/React.createElement(SingleTrackingStepComponent, {
      key: idx,
      text: isFinance ? step.text ? step.text : "" : step.title ? step.title : "",
      note: isFinance ? step.in_progress_text ? step.in_progress_text : "" : step.sub_title ? step.sub_title : "",
      title: step === null || step === void 0 ? void 0 : step.title,
      status: status[idx],
      step: step,
      details: details,
      isFinance: isFinance,
      status_key: isFinance ? idx + 1 : step.status_key
    }));
  }))))), completed && /*#__PURE__*/React.createElement("div", {
    className: stl.expansionButtonBox
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleExpand
  }, collapsed ? t("view_details", {
    ns: "web_tracking_finance"
  }) : t("hide_details", {
    ns: "web_tracking_finance"
  }))), /*#__PURE__*/React.createElement("div", null, (details === null || details === void 0 ? void 0 : (_details$referer_code = details.referer_code) === null || _details$referer_code === void 0 ? void 0 : _details$referer_code.code) && /*#__PURE__*/React.createElement(CopyCodeComponent, {
    details: details
  }))));
};
export default TrackingStepsComponent;